import { GridItem } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { Creator } from "@nens/rana/api-v1";
import { RanaButton, RightArrowIcon } from "@nens/ranalib";
import { TenantUser } from "@nens/ranalib";

import { FILTER_CONTRIBUTOR_ID_KEY } from "@/config/query-parameter-consts";
import { useTenantActionAllowed } from "@/hooks/use-action-allowed-in-tenant";

import { ContentPanel } from "../../../components/content-panel";
import { RanaLink } from "../../../components/rana-link";
import { DASHBOARD_GRID_ITEM_HEIGHT } from "../tenant-details";

import { TenantMyProjectList } from "./tenant-my-project-list";

interface MyProjectsBlockProps {
  tenant: string;
  user: TenantUser | Creator;
}

export const MyProjectsBlock = ({ tenant, user }: MyProjectsBlockProps) => {
  const intl = useIntl();
  const { canCreateNewProject } = useTenantActionAllowed();

  return (
    <GridItem height={DASHBOARD_GRID_ITEM_HEIGHT}>
      <ContentPanel
        p={0}
        title={intl.formatMessage({ id: "dashboard.my_projects", defaultMessage: "My projects" })}
        rightLink={
          canCreateNewProject ? (
            <RanaButton variant="fourthiary">
              <RanaLink
                to={`/${tenant}/projects-new`}
                queryParams={"id" in user ? `${FILTER_CONTRIBUTOR_ID_KEY}=${user.id}` : undefined}
                textDecor="none !important"
              >
                {intl.formatMessage({
                  id: "dashboard.all_my_projects",
                  defaultMessage: "Create project",
                })}
                <RightArrowIcon ml={1} />
              </RanaLink>
            </RanaButton>
          ) : undefined
        }
      >
        <TenantMyProjectList />
      </ContentPanel>
    </GridItem>
  );
};
